// extracted by mini-css-extract-plugin
export default {"espacamento":"Botao_espacamento__CtFs9"};